import { useMemo } from 'react';

/** Лише UA — один запис для react-phone-number-input `labels`. */
export const usePhoneCountryLabels = ({ language }: { language: string }) => {
  const labels = useMemo(() => {
    const isUa = language.toLowerCase().startsWith('ua');
    return { UA: isUa ? 'Україна' : 'Ukraine' } as Record<string, string>;
  }, [language]);

  return { labels };
};
